const Size = size => {
  switch (size) {
    case 'xl':
      return `
        min-width:260px;
        min-height:50px;`;

    case 'lg':
      return `
        min-width:230px;
        min-height:45px;`;

    case 'md':
      return `
        min-width:180px;
        min-height:40px;`;

    case 'sm':
      return `
        min-width:136px;
        min-height:35px;`;

    case 'xs':
      return `
        min-width:64px;
        min-height:30px;`;

    case 'fullWidth':
      return `
        width: 100%;
        height: 40px;`
    
    default:
      return `
        min-width:136px;
        min-height:35px;`;
  }
}

export default Size;


// WEBPACK FOOTER //
// ./client/components/Styled/Button/Size.js